// scroll bar
import "simplebar/src/simplebar.css";

import io from "socket.io-client";
// lightbox
/* eslint-disable import/no-unresolved */
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// map
import "./utils/mapboxgl";
import "mapbox-gl/dist/mapbox-gl.css";

// editor
import "react-quill/dist/quill.snow.css";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";

// ----------------------------------------------------------------------
import { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
// redux
import { store, persistor } from "./redux/store";
// routes
import Router from "./routes";
// theme
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ThemeProvider from "./theme";
import { StyledChart } from "./components/chart";
import SnackbarProvider from "./components/snackbar";
import ScrollToTop from "./components/scroll-to-top";
import { MotionLazyContainer } from "./components/animate";
import { ThemeSettings, SettingsProvider } from "./components/settings";
import { AuthProvider } from "./auth/JwtContext";
import { CartProvider } from "./pages/Venue/CartContext";
import { UserLocationEnabledProvider } from "./components/settings/UserLocationEnabled";

export const socket = io.connect(process.env.REACT_APP_SOCKET_URL);

export default function App() {

  useEffect(() => {
    const isProduction = process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'staging';
    const script = document.createElement('script');
    script.src = isProduction
      ? 'https://js.xstak.com/v2/xpay.js'
      : 'https://js.xstak.com/v2/xpay-stage.js';
    script.onload = () => {
      console.log('Payment script loaded successfully');
      window.__isXpayLoaded = true
    };
    script.onerror = () => {
      console.error('Error loading payment script');
    };
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const isProduction = process.env.REACT_APP_ENV === 'production';
    if (isProduction) {
      const script = document.createElement('script');
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-GZ9Z7FWYS2";
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-GZ9Z7FWYS2');
      };
    }
  }, []);

  return (
    <ReduxProvider store={store}>
      <CartProvider>
        <AuthProvider>
          <HelmetProvider>
            <PersistGate loading={null} persistor={persistor}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SettingsProvider>
                  <UserLocationEnabledProvider>
                    <BrowserRouter>
                      <ScrollToTop />
                      <MotionLazyContainer>
                        <ThemeProvider>
                          <ThemeSettings>
                            <SnackbarProvider>
                              <StyledChart />
                              <Router />
                            </SnackbarProvider>
                          </ThemeSettings>
                        </ThemeProvider>
                      </MotionLazyContainer>
                    </BrowserRouter>
                  </UserLocationEnabledProvider>
                </SettingsProvider>
              </LocalizationProvider>
            </PersistGate>
          </HelmetProvider>
        </AuthProvider>
      </CartProvider>
    </ReduxProvider>
  );
}
